import React from 'react';
import { VictoryContainer, VictoryPie, VictoryLegend } from 'victory';

const VendorPieChart = (props) => {
   const totalCount = props.items.reduce((total, item) => {
      total += item.numberSales;
      return total;
   }, 0);

   return (
      <>
         <VictoryPie
            containerComponent={<VictoryContainer responsive={false} />}
            domainPadding={{ x: 20 }}
            style={{
               labels: {
                  fontSize: 10,
                  fill: '#c28005',
               },
            }}
            // colorScale={['#003f5c', '#2f4b7c', '#665191', '#a05195', '#d45087', '#f95d6a', '#ff7c43', '#ffa600']}
            colorScale={['#f95d6a', '#2f4b7c', '#665191', '#a05195', '#d45087', '#f95d6a', '#ff7c43', '#ffa600']}
            // standalone={false}
            width={props.width}
            height={props.height}
            data={props.items}
            labels={({ datum }) => {
               return `${datum.xName}  ${Math.round((datum.numberSales / totalCount) * 100)}%`;
            }}
            x='vendorName'
            y={['totalSalesAmount']}
            innerRadius={45}
            labelRadius={props.width / 6.8}
         ></VictoryPie>
      </>
   );
};

export default VendorPieChart;
